import { useLocation, useNavigate } from "react-router-dom";
// import { Container } from "react-bootstrap";
import "./filters.css";
import { ProjectData } from "@/pages/Project";

type ProjectPreview = Pick<
  ProjectData,
  "id" | "title" | "imgUrl" | "details" | "list" | "date" | "tags" | "type"
>;

interface FiltersProps {
  projects: ProjectPreview[];
  setProjects: React.Dispatch<React.SetStateAction<ProjectPreview[]>>;
}

const Filters: React.FC<FiltersProps> = ({ projects }) => {
  const navigate = useNavigate();
  const location = useLocation();

  // Define fixed categories with their routes and display names
  const categories = [
    {
      key: "all",
      label: "toate", 
      route: "/portfoliu",
      type: null // null means all types
    },
    {
      key: "websituri",
      label: "websiteuri",
      route: "/portfoliu/websiteuri-de-prezentare", 
      type: "websituri"
    },
    {
      key: "e-commerce",
      label: "e-commerce",
      route: "/portfoliu/e-commerce",
      type: "ecommerce"
    },
    {
      key: "smm-content",
      label: "SMM-Content", 
      route: "/portfoliu/smm-content",
      type: "SMM și content"
    },
    {
      key: "branding",
      label: "branding",
      route: "/portfoliu/branding",
      type: "branding"
    }
  ];

  // Get project count for each category (with hardcoded SMM count)
  const getProjectCount = (type: string | null) => {
    if (type === null) return projects.length; // All projects (currently 1)
    if (type === "SMM și content") return 10; // Updated SMM count (4 images + 6 videos)
    return projects.filter(project => project.type === type).length;
  };

  // Filter out categories with zero count
  const visibleCategories = categories.filter(category => {
    const count = getProjectCount(category.type);
    return count > 0;
  });

  // Handle navigation
  const handleNavigation = (route: string) => {
    navigate(route);
  };

  // Determine active filter based on current route
  const getActiveCategory = () => {
    const currentPath = location.pathname;
    const activeCategory = categories.find(cat => cat.route === currentPath);
    return activeCategory?.key || "all";
  };

  const activeType = getActiveCategory();

  return (
    <div style={{ 
      display: "flex", 
      justifyContent: "center", 
      gap: "20px", 
      flexWrap: "wrap" 
    }}>
      {visibleCategories.map((category) => {
        const projectCount = getProjectCount(category.type);
        
        return (
          <button
            className={`filter-button ${
              activeType === category.key ? "active" : ""
            }`}
            onClick={() => handleNavigation(category.route)}
            key={category.key}
            style={{
              background: "none",
              border: "2px solid #93f8d1",
              padding: "8px 16px",
              borderRadius: "25px",
              cursor: "pointer",
              fontSize: "1.2rem"
            }}
          >
            <span className="filter-label">{category.label}</span>
            <span className="filter-count" style={{ marginLeft: "8px", opacity: "0.7" }}>
              {projectCount}
            </span>
          </button>
        );
      })}
    </div>
  );
};

export default Filters;